module.exports = __webpack_public_path__ + "img/rewind.a6664117.png";